<script>
    import scus from "state-counties-us";
  import { afterUpdate } from "svelte";

  export let value, id, invalid, state;

  let counties = [];

  afterUpdate(() => {
    counties = scus.getCountiesByState(state).map((f, i) => {
      return {
        name: f,
        value: f.toUpperCase(),
      };
    });

    let valid = counties.filter((c) => {
      return c.value === value;
    });

    if (!valid.length) {
      value = "";
    }
  });
</script>

<select class="form-select" {id} bind:value class:is-invalid={invalid}>
  <option selected disabled value="">Choose County</option>
  {#each counties as county}
    <option value={county.value}>{county.name}</option>
  {/each}
</select>
<label for={id}>County</label>
